import axiosInstance from './axiosInstance';

// 获取所有Banner
export const getBanners = async () => {
  const response = await axiosInstance.get('/banners');
  return response.data;
};

// 创建新Banner
export const createBanner = async (bannerData) => {
  const response = await axiosInstance.post('/banners', bannerData);
  return response.data;
};

// 更新Banner
export const updateBanner = async (id, bannerData) => {
  const response = await axiosInstance.put(`/banners/${id}`, bannerData);
  return response.data;
};

// 删除Banner
export const deleteBanner = async (id) => {
  const response = await axiosInstance.delete(`/banners/${id}`);
  return response.data;
};